import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ViewportService } from '@shared/services/viewport.service';
import { LocaleService } from '@shared/services/locale.service';
import { NumbersService } from '@shared/services/numbers.service';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { SnackService } from '@shared/services/snack.service';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Component({
	selector: 'app-payment-temp',
	templateUrl: './payment-temp.component.html',
	styleUrls: ['./payment-temp.component.scss'],
})
export class PaymentTempComponent implements OnInit {
	/*
	 *** THIS IS A TEMPORARY COMPONENT WHICH SHOULD BE DELETED WHEN PAYMENT PAGE BECOMES AVAILABLE ON THE MOBILE APPS ***
	 */

	constructor(
		private http: HttpClient,
		private title: Title,
		private router: Router,
		private route: ActivatedRoute,
		private snack: SnackService,
		public viewport: ViewportService,
		public locale: LocaleService,
		public numbers: NumbersService
	) {}

	embedded: boolean = false;
	loading: boolean = false;
	vouchers: string[] = ['voucherCode1'];
	queryPackage: string;

	form: UntypedFormGroup = new UntypedFormGroup({
		adID: new UntypedFormControl('', Validators.required),
		voucherCode1: new UntypedFormControl('', Validators.required),
	});

	onKeyUp(field: string) {
		this.form.get(field).setValue(this.numbers.toNumeric(this.form.get(field).value.toString().replace(/\s/g, '')));
	}

	onAddVoucherControl() {
		const newControlName: string = 'voucherCode' + (this.vouchers.length + 1).toString();
		this.form.addControl(newControlName, new UntypedFormControl('', Validators.required));
		this.vouchers.push(newControlName);
	}

	onSubmit() {
		this.loading = true;

		const body: FormData = new FormData();

		var voucherCodes: string[] = [];
		this.vouchers.forEach((voucher) => {
			voucherCodes.push(this.form['value'][voucher]);
		});

		body.append('lang', this.locale.lang);
		body.append('adID', this.form['value']['adID']);
		body.append('voucherCode[]', voucherCodes.toString());

		if (this.queryPackage) {
			body.append('package', this.queryPackage === 'premium' ? '1' : '2');
		}

		this.http.post(environment['api'] + 'tempPayVoucher', body).subscribe(
			(res) => {
				if (res['status'] === '1') {
					this.router.navigate(['/payment/success'], {
						queryParams: {
							adID: this.form['value']['adID'],
						},
					});
				} else {
					this.snack.open(this.locale.translations['ads']['ad']['n40']);
				}

				this.loading = false;
			},
			(err) => {
				console.error(err);
				this.snack.open(this.locale.translations['misc']['n174']);
				this.loading = false;
			}
		);
	}

	ngOnInit(): void {
		this.title.setTitle('Payment | Kurd Shopping');

		this.route.queryParams.subscribe((queries: Params) => {
			if (queries['adID']) {
				this.form.get('adID').setValue(queries['adID']);
			}

			this.embedded = queries['embedded'];
			this.queryPackage = queries['package'];
		});
	}
}
